export const ACTION = {
    GET_APP_INSTALL_DETAILS: 'GET_APP_INSTALL_DETAILS',
}